var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
/**
 * Response of `GET /v1/offices/:officeId/dunningRun/in-flight` — the resume-on-reopen
 * lookup performed by the DunningRun sidebar. Returns the id of the current in-flight
 * (PENDING / IN_PROGRESS) `DunningRun` for any of the caller's allowed OfficeLocations
 * within the office, or `null` when no run is in flight.
 *
 * The frontend short-circuits straight to the Running view when `dunningRunId` is set
 * instead of defaulting to Candidates.
 */
export class InFlightDunningRunResponseDto {
    dunningRunId;
}
__decorate([
    Expose(),
    __metadata("design:type", Object)
], InFlightDunningRunResponseDto.prototype, "dunningRunId", void 0);
//# sourceMappingURL=in-flight-dunning-run.response.dto.js.map